import {
  BillingMode,
  ContractStatus,
  PaymentFrequency,
  PaymentMethod,
  ContractReasonCancellation,
} from '@/app/shared/enums';
import {
  CustomerBillingModel,
  InstallmentModel,
  PaymentInfoModel,
} from '@/app/shared/models';
import { Model } from '@/app/shared/models/model';

export class ContractModel extends Model {
  public Number?: number;
  public Status?: ContractStatus;
  public BillingMode?: BillingMode;
  public PaymentMethod?: PaymentMethod;
  public Frequency?: PaymentFrequency;
  public Value?: number;
  public Amount?: number;
  public CurrencyCode?: string;
  public FirstPaymentValue?: number;
  public FirstPaymentDate?: Date;
  public NumberOfInstallments?: number;
  public DueDate?: number;
  public StartDate?: Date;
  public FinishDate?: Date | string;
  public CancelationDate?: Date;
  public OurCode?: string;
  public Infinite?: boolean;
  public AutoRenew?: boolean;
  public CurrentInstallmentNumber?: number;

  public Customers?: CustomerBillingModel[];
  public PaymentInfos?: PaymentInfoModel[];
  public Installments?: InstallmentModel[];

  public Updated?: Date;
  public DueDateUpdateDate?: Date;
  public ReasonForCancellation?: ContractReasonCancellation;
}
